/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * fields with hard references are used throughout our app. This allows clients to customize
 * how these fields are present on the FE via the field name, but the reference remains the same, so
 * the application can find and operate on these fields.
 */
export enum ReferenceFieldEnum {
    LUMONIC_ID = 'LUMONIC_ID',
    ENTITY_NAME = 'ENTITY_NAME',
    ENTITY_FISCAL_YEAR_END = 'ENTITY_FISCAL_YEAR_END',
    ENTITY_REPORTING_CURRENCY = 'ENTITY_REPORTING_CURRENCY',
    ENTITY_DELIVERABLE_COLLECTION_STATUS = 'ENTITY_DELIVERABLE_COLLECTION_STATUS',
    ENTITY_DELIVERABLE_COLLECTION_STRATEGY = 'ENTITY_DELIVERABLE_COLLECTION_STRATEGY',
}
